// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OutletOrderFormats_gridContainer__S1Pqa","selected":"OutletOrderFormats_selected__UXQZ6"};